import { render, staticRenderFns } from "./MetalPricingHistory.vue?vue&type=template&id=7a1ba896&scoped=true&"
import script from "./MetalPricingHistory.vue?vue&type=script&lang=js&"
export * from "./MetalPricingHistory.vue?vue&type=script&lang=js&"
import style0 from "./MetalPricingHistory.vue?vue&type=style&index=0&id=7a1ba896&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ba896",
  null
  
)

export default component.exports